import { render, staticRenderFns } from "./ProductsListPage.vue?vue&type=template&id=9ffcd74e&"
import script from "./ProductsListPage.vue?vue&type=script&lang=ts&"
export * from "./ProductsListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports